function injectStyle (ssrContext) {
  require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-440a59f8\",\"scoped\":false,\"hasInlineConfig\":false}!./Multiselect.css")
}
var normalizeComponent = require("!../../vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Multiselect.vue"
/* template */
import __vue_template__ from "!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-440a59f8\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../vue-loader/lib/selector?type=template&index=0!./Multiselect.vue"
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-components/vue-multiselect/Multiselect.vue
// module id = wFFX
// module chunks = 1